import { Link } from "react-router-dom";
import { Section, Card, CTA } from "@/components/Section";
import { CheckCircle2 } from "lucide-react";

const OUTPUTS = [
  "Decision-making protocols",
  "Difficult-conversation preparation tools",
  "Time-sensitive communication workflows",
  "Leadership prompt libraries",
  "Strategic-planning assistants",
  "Meeting-agenda and follow-up systems",
  "Research and information-synthesis tools",
  "Team onboarding resources",
  "Data-review frameworks",
  "Custom AI agents",
  "Websites and landing pages",
  "Professional presentations",
  "Implementation roadmaps",
];

export default function WhatYouWillBuild() {
  return (
    <div data-testid="page-build">
      <Section eyebrow="What You Will Build" title="You will leave with more than information. You will leave with something you built."
        kicker="A practical view of the resources leaders and teams create in our engagements.">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {OUTPUTS.map((o, i) => (
            <Card key={o} data-testid={`output-${i}`}>
              <div className="flex items-start gap-3">
                <CheckCircle2 size={18} className="text-[var(--layor-gold)] mt-1" />
                <div className="font-semibold text-[var(--layor-navy)] leading-snug">{o}</div>
              </div>
            </Card>
          ))}
        </div>
      </Section>

      <CTA
        dark
        headline="Bring your leadership in the room. Leave with tools you built and can use tomorrow."
        actions={
          <>
            <Link to="/contact" className="btn-gold rounded-full px-5 py-3 text-sm font-semibold">Book a Consultation</Link>
            <Link to="/quote?service=Training%20or%20Workshop" className="rounded-full px-5 py-3 text-sm font-semibold border border-white/30 text-white hover:bg-white hover:text-[var(--layor-navy)]">Request Training</Link>
          </>
        }
      />
    </div>
  );
}
